import { DetailedHTMLProps, SelectHTMLAttributes } from "react";
import Select, { components } from "react-select";

const Option = (props, className) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="flex items-center space-x-2 z-40 ">
          <input
            className={`flex items-center space-x-2 hover:bg-white${className}`}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label className="">{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};

const customStyles = {
  multiValueRemove: (provided) => ({
    ...provided,
    display: "none",
  }),
  multiValue: (provided) => ({
    ...provided,
    textOverflow: "ellipsis",
    maxWidth: "70%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    backgroundColor: "transparent",
    padding: "0",
  }),
  option: (provided, state) => ({
    ...provided,
    active: "",
    padding: "3px",
    color: "black",
    backgroundColor: "white",
    fontSize: "12px",
  }),

  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    border: "0",
    minHeight: "26px",
    height: "26px",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "26px",
    padding: "0px 6px",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "28px",
    margin: "0px",
  }),

  menu: (provided, state) => ({
    ...provided,
    overflowX: "auto",
    paddingLeft: "10px",
    height: "max",
  }),
};

const valueContainer = ({ children, ...props }) => {
  let [values, input] = children;

  if (Array.isArray(values)) {
    values =
      values.length > 1
        ? values.length === props.options.length
          ? "ALL"
          : `Selected (${values.length}) `
        : values;
  } else {
    values =
      input.props?.value?.length > 0 ? values : "Select multiple options...";
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

interface ISelectHookFormMulti_DA
  extends DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  field?: any;
  options: any[];
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
  label?: string;
  isMulti?: boolean;
  onChange?: any;
  value?: any;
  isLoading?: boolean;
  secondDiv?: string;
}
const SelectHookFormMultiDA: React.FC<ISelectHookFormMulti_DA> = ({
  field,
  options,
  isDisabled,
  className,
  label,
  onChange, // send value to hook form
  value = [],
  isMulti = true,
  isLoading,
  secondDiv = "md:grid-cols-3 items-center",
  isRequired,
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`grid ${secondDiv} w-full items-start`}>
        {label && (
          <label
            className={`flex items-stretch text-left expandedLabel fontExpand`}
          >
            {isRequired && (
              <span className="text-red-500 font-bold self-start">*</span>
            )}
            {label}:
          </label>
        )}

        <Select
          className={`${
            className ? className : "border border-gray-300 col-span-2"
          } rounded-sm text-xs focus:ring-quaternary focus:border-quaternary  ${
            isDisabled && "opacity-20 "
          }`}
          {...field}
          onChange={onChange}
          value={
            Array.isArray(value) && value.length > 0
              ? value.find(
                  (x: { value: any }) =>
                    typeof x.value === "string" &&
                    x.value.toUpperCase() === "ALL"
                )
                ? options
                : value
              : null
          }
          options={options}
          isMulti={isMulti}
          isSearchable
          isClearable
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          styles={customStyles}
          isDisabled={isDisabled}
          components={{
            ValueContainer: valueContainer,
            Option,
          }}
          tabSelectsValue={false}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default SelectHookFormMultiDA;
